import(/* webpackMode: "eager", webpackExports: ["HeadingLevel"] */ "/usr/src/app/node_modules/@ariakit/react/esm/index.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/app/upptack/page.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/Discover/CategoriesDisplay.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["DiscoveryResult"] */ "/usr/src/app/src/components/Discover/DiscoveryResult.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Search"] */ "/usr/src/app/src/components/Discover/Search.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/Icon/Icon.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/ImageIcon/ImageIcon.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/DotLoader/DotLoader.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["PulseViewEvent"] */ "/usr/src/app/src/components/pulse/PulseViewEvent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LogoutController"] */ "/usr/src/app/src/utils/auth/LogoutController.tsx");
